import React from "react";
import "./Frame222.css";

function Frame222(props) {
  const { children } = props;

  return (
    <div className="frame-2-11">
      <div className="continue-6 valign-text-middle inter-bold-mineral-green-18px">{children}</div>
    </div>
  );
}

export default Frame222;
